module.exports = __webpack_public_path__ + "media/images/coffee-9b63b8ce46f80795e4718e16deb76d08.png";